import React, { Component } from 'react';
import {Input, Button} from 'reactstrap';
import size from 'lodash/size';
import isEmpty from 'lodash/isEmpty';
import axios from 'axios';

class TitleInput extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      title: this.props.editTitle?this.props.editTitle: "" 
     }

    //  console.log(this.props)
  }

  
  componentDidMount(){
    // axios.get
  }


  renderContent=()=>{
    let res = [],
    {task}=this.props

    let{lastModified}=task
    
    if(lastModified){
      res.concat(lastModified)
    } else {
      let obj = {
        createdOn: task.createdOn,
        userId:task.userId,
        updatedFields: ['created']
      }

      if(res&&res.length>0){
        return (
          res.map(e=>{
            return (
              <div>

              </div>
            )
          })
        )
      }
    }


  }

  render() { 
      let {title} = this.state
      const { description } = this.props;
    return ( 
      <div>
        {this.renderContent()}
      </div>
    );
  }
}
 
export default TitleInput;